import React from 'react';

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onClear?: () => void;
}

export function SearchInput({ onClear, value, className = '', ...props }: SearchInputProps) {
  return (
    <div className={`search-container ${className}`}>
      <i className="fa-solid fa-magnifying-glass search-icon"></i>
      <input type="text" className="search-input" value={value} {...props} />
      {value && onClear && (
        <button className="search-clear" onClick={onClear} title="Clear search">
          <i className="fa-solid fa-xmark"></i>
        </button>
      )}
    </div>
  );
}
